app.controller('trophyIndexCtrl', [
    '$scope', 'gameService', '$timeout', function ($scope, gameService, $timeout) {

    	$scope.score = gameService.gameState.score;
    	
        var teamName = gameService.teamName;
        var trimmedTeamName = teamName;
        if (teamName.length > 15) {
            trimmedTeamName = trimmedTeamName.substr(0, 15) + "...";
        }
        $scope.teamName = teamName;
        $scope.trophyTeamName = trimmedTeamName;

        $scope.confetti = new TG.Confetti({
            viewport: document.getElementsByClassName("confetticanvas")[0],
            texture: '/img/confetti-sprite.png',
            particleCount: 759,
            particleScale: 1.0
        });

        $scope.fireConfettiLoop = function() {
            $timeout(function() {
                $scope.confetti.fireLeftCannon();
                $timeout(function() {
                    $scope.confetti.fireRightCannon();
                    $timeout(function() {
                        $scope.confetti.fireCenterCannon();
                        $timeout(function() {
                            $scope.initiateConfettiLoop();
                        }, 2250);
                    }, 2250);
                }, 750);
            }, 750);
        }

        $scope.initiateConfettiLoop = function() {
            $scope.fireConfettiLoop();
        }

        $scope.initiateConfettiLoop();

        $scope.$on('$destroy', function() {
            $scope.confetti.dispose();
        });
   }
]);